import firebase from "firebase/app"
import "firebase/auth"
import { buyerConfigDev, buyerConfigProd } from "./buyerConfig"

const getConfig = () => {
  let config = buyerConfigDev
  if (process.env.REACT_APP_ENV === "production") {
    config = buyerConfigProd
  } else if (process.env.REACT_APP_ENV === "staging") {
    config = buyerConfigDev
  } else {
    config = buyerConfigDev
  }
  return config
}

export const firebuyer = firebase.initializeApp(getConfig(), "buyer")
export const buyerGoogleProvider = new firebase.auth.GoogleAuthProvider()
export const buyerFbProvider = new firebase.auth.FacebookAuthProvider()
